<template>
  <div
    v-if="getDetailsWidget"
    :class="[
      'metrics-card',
      layer.type,
      { demand: layer.type === 'DEMAND' },
      { supply: layer.type === 'SUPPLY' },
    ]"
  >
    <div class="header">
      <div class="header-texts">
        <h4 class="title ellipsis">
          {{ layer.name }}
        </h4>
        <p class="description">Change since last period</p>
      </div>
      <div class="values align-right">
        <span class="value">{{ getEventDetails.current }}</span>
        <span
          :class="['percentage', { decreasing: !getEventDetails.isIncreasing }]"
          >{{ getEventDetails.change }}%</span
        >
      </div>
    </div>

    <div class="header">
      <div class="flex-col flex-expand">
        <h4 class="title ellipsis">Total Entities</h4>
        <div class="values">
          <div class="flex-col">
            <p class="value padding-top">{{ getEntitiesDetails.current }}</p>
            <span
              :class="[
                'percentage',
                { decreasing: !getEntitiesDetails.isIncreasing },
              ]"
              >{{ getEntitiesDetails.change }}%</span
            >
          </div>
        </div>
      </div>
      <div class="flex-col flex-expand">
        <h4 class="title ellipsis">Total Sessions</h4>
        <div class="values">
          <div class="flex-col">
            <p class="value padding-top">{{ getSessionDetails.current }}</p>
            <span
              :class="[
                'percentage',
                { decreasing: !getSessionDetails.isIncreasing },
              ]"
              >{{ getSessionDetails.change }}%</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    layer: Object,
  },
  computed: {
    ...mapGetters("SupplyDemand", ["getDetailsWidget"]),
    getEventDetails() {
      const data = this.getDetailsWidget(this.layer.id);
      if (!(data && data.event_count && data.event_count.current))
        return {
          current: 0,
          change: 0,
        };

      return this.calculateIncrease(data.event_count);
    },
    getSessionDetails() {
      const data = this.getDetailsWidget(this.layer.id);
      if (!(data && data.entities_count && data.entities_count.current))
        return {
          current: 0,
          change: 0,
        };

      return this.calculateIncrease(data.entities_count);
    },
    getEntitiesDetails() {
      const data = this.getDetailsWidget(this.layer.id);
      if (!(data && data.sessions_count && data.sessions_count.current))
        return {
          current: 0,
          change: 0,
        };

      return this.calculateIncrease(data.sessions_count);
    },
  },
  methods: {
    formatNumber(num) {
      let value = parseFloat(num || 0);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(2), 2);
      return value;
    },
    calculateIncrease({ current, previous }) {
      const isIncreasing = current > previous ? true : false;
      return {
        current: this.formatNumber(current),
        change: this.formatNumber(
          isIncreasing ? (previous / current) * 100 : (current / previous) * 100
        ),
        isIncreasing,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-card {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  margin: 10px 10px;

  &.demand {
    border-top: 3px solid var(--color-accent);
  }

  &.supply {
    border-top: 3px solid var(--color-primary);
  }

  .header {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 10px;
    border-bottom: 1px solid var(--border-color);
    padding-top: 15px;

    .header-texts {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
    }

    &:last-child {
      border-bottom: 0;
    }

    h4 {
      font-size: 1em;
    }
    p {
      margin: 0;
      padding: 0;
    }

    .description {
      font-size: 0.8;
      opacity: 0.7;
    }
  }

  .values {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 0;

    &.align-right {
      align-items: flex-end;
    }

    .value {
      font-size: 1.3em;
      padding-bottom: 2px;

      &.padding-top {
        padding-top: 10px;
      }
    }

    label {
      font-size: 0.7em;
    }

    .percentage {
      color: #16f559;

      &::before {
        content: "+";
      }

      &.decreasing {
        color: #f84b20;
        &::before {
          content: "-";
        }
      }
    }
  }

  // .metric-area {
  //   display: flex;
  //   flex-
  // }
}
</style>
